const initialState = {
    isLoading: true,
    isLogin: false
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SEND_LOGIN_REQ":
            return { ...state, isLoading: true };

        case "GET_LOGIN_RES":
            return { isLoading: false, isLogin: true };

        case "GET_LOGIN_ERR":
            return { isLoading: false, isLogin: false };

        default:
            return state;
    }
};

export default loginReducer;